module.exports = __webpack_public_path__ + "assets/HKNova-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Medium.woff2
// module id = 133
// module chunks = 0